import react, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import toastr from "toastr";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  FacebookShareCount,
  GabIcon,
  GabShareButton,
  HatenaIcon,
  HatenaShareButton,
  HatenaShareCount,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  LivejournalIcon,
  LivejournalShareButton,
  MailruIcon,
  MailruShareButton,
  OKIcon,
  OKShareButton,
  OKShareCount,
  PinterestIcon,
  PinterestShareButton,
  PinterestShareCount,
  PocketIcon,
  PocketShareButton,
  RedditIcon,
  RedditShareButton,
  RedditShareCount,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TumblrShareCount,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  VKIcon,
  VKShareButton,
  VKShareCount,
  WeiboIcon,
  WeiboShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  WorkplaceIcon,
  WorkplaceShareButton,
  XIcon,
} from "react-share";
const shareUrl = "http://github.com";
const title = "GitHub";
export default function Share(props) {
  const [nftLink, setNftLink] = useState()
  const [title, setTitle] = useState('')
  const location = useLocation()
  useEffect(() => {
    let link = "https://market.terpnash.com"
    link += location.pathname
    setNftLink(link)
  }, [location])
  const CloseDialog = () => {
    props.fucn();
  };

  const [shareData, setShareData] = useState();
  useEffect(() => {
    setShareData(props?.sharedata);
  }, [props]);

  function setData(name) {
    if (name === "facebookMessenger") {

    }

  }
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(nftLink)
    toastr.success("Copied to clipboard!");
  }
  return (
    <>
      {/* <div className="dialogHeader px-3">
        <h3>Share </h3>
        <button onClick={CloseDialog}>
          <i className="fa-regular fa-xmark"></i>
        </button>
      </div> */}
      <div className="shareBody">
        <ul>
          <li onClick={() => setData("facebook")}>

            <FacebookShareButton
              className="Demo__some-network__share-button"
              url={nftLink}

            >
              <FacebookIcon size={40} round />
              <div className="shareBtnName">
                <h5>Facebook</h5>
              </div>
            </FacebookShareButton>

            {/* <FacebookShareCount url={shareData?.nftLink} /> */}
          </li>
          <li onClick={() => setData("facebookMessenger")}>
            <FacebookMessengerShareButton
              url={shareData?.nftLink}
              title={shareData?.nftName}
              className="Demo__some-network__share-button"
            >
              <FacebookMessengerIcon size={40} round />
              <div className="shareBtnName">
                <h5>Messenger</h5>
              </div>
            </FacebookMessengerShareButton>
          </li>
          <li onClick={() => setData("telegram")}>
            <TelegramShareButton
              url={nftLink}
              title={shareData?.nftName}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={40} round />
              <div className="shareBtnName">
                <h5>Telegram</h5>
              </div>
            </TelegramShareButton>
          </li>
          <li onClick={() => setData("whatsapp")}>
            <WhatsappShareButton
              url={nftLink}
              title={shareData?.nftName}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={40} round />
              <div className="shareBtnName">
                <h5>WhatsApp </h5>
              </div>
            </WhatsappShareButton>
          </li>
          <li onClick={() => setData("linkedIn")}>
            <LinkedinShareButton
              url={nftLink}
              title={shareData?.nftName}
              source={"terpnash.com"}
              className="Demo__some-network__share-button"
            >
              <LinkedinIcon size={40} round />
              <div className="shareBtnName">
                <h5>LinkedIn</h5>
              </div>
            </LinkedinShareButton>
          </li>
          <li onClick={() => setData("linkedIn")}>
           <button style={{height:'40px'}}>
           <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26" rx="13" fill="#3899F2"/>
<path d="M14.62 8H12.673C11.791 8 11.092 8 10.5455 8.074C9.9825 8.15 9.527 8.31 9.168 8.6705C8.8085 9.031 8.649 9.4885 8.5735 10.0535C8.5 10.6025 8.5 11.304 8.5 12.1895V15.1085C8.5 15.8625 8.96 16.5085 9.6135 16.7795C9.58 16.3245 9.58 15.687 9.58 15.156V12.651C9.58 12.0105 9.58 11.458 9.639 11.016C9.7025 10.542 9.8455 10.088 10.2125 9.7195C10.5795 9.351 11.032 9.2075 11.504 9.1435C11.944 9.0845 12.494 9.0845 13.1325 9.0845H14.6675C15.3055 9.0845 15.8545 9.0845 16.295 9.1435C16.163 8.80669 15.9326 8.51745 15.6338 8.31348C15.335 8.10951 14.9818 8.00027 14.62 8Z" fill="white"/>
<path d="M10.3 12.6984C10.3 11.3354 10.3 10.6539 10.722 10.2304C11.1435 9.80688 11.822 9.80688 13.18 9.80688H14.62C15.9775 9.80688 16.6565 9.80688 17.0785 10.2304C17.5 10.6539 17.5 11.3354 17.5 12.6984V15.1084C17.5 16.4714 17.5 17.1529 17.0785 17.5764C16.6565 17.9999 15.9775 17.9999 14.62 17.9999H13.18C11.8225 17.9999 11.1435 17.9999 10.722 17.5764C10.3 17.1529 10.3 16.4714 10.3 15.1084V12.6984Z" fill="white"/>
</svg>


              <div className="shareBtnName" onClick={handleCopyToClipboard}>
                <h5>Copy Link</h5>
              </div>
           </button>
          </li>
        </ul>
      </div>
    </>
  );
}